import {Directive, ElementRef, EventEmitter, Inject, OnDestroy, OnInit, Output, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {fromEvent, Subscription} from 'rxjs';
import {delay, tap} from 'rxjs/operators';

@Directive({
    selector: '[ngxOutsideClick]'
})
export class NgxOutsideClick implements OnInit, OnDestroy {

    /**
     * The emitter that emits when the click was outside the host.
     */
    @Output() ngxOutsideClick = new EventEmitter<object>();

    /**
     * If the directive is listening.
     */
    private _listening = false;

    /**
     * The subscription that handles the click observable.
     */
    private _clickSubscription: Subscription;

    constructor(private _element: ElementRef,
                @Inject(PLATFORM_ID) private _platformId: object) {
    }

    ngOnInit() {
        // Check if the current platform is a browser.
        if (!isPlatformBrowser(this._platformId)) {
            return;
        }

        // Save the click subscription to an instance variable for later
        // reference.
        this._clickSubscription = fromEvent(document, 'click').pipe(
            delay(1),
            tap(() => this._listening = true)
        ).subscribe((event: MouseEvent) => this.onGlobalClick(event));
    }

    ngOnDestroy() {
        if (this._clickSubscription) {
            this._clickSubscription.unsubscribe();
        }
    }

    private onGlobalClick(event: MouseEvent) {
        if (event instanceof MouseEvent && this._listening) {
            this.ngxOutsideClick.emit({
                target: (event.target || null),
                value: !this.isDescendant(this._element.nativeElement, event.target)
            });
        }
    }

    private isDescendant(parent, child) {
        let node = child;

        while (node !== null) {
            if (node === parent) {
                return true;
            }

            node = node.parentNode;
        }

        return false;
    }

}
